import { render, staticRenderFns } from "./Click2PayPrcessErrorModal.vue?vue&type=template&id=6c303ee5&scoped=true"
import script from "./Click2PayPrcessErrorModal.vue?vue&type=script&lang=js"
export * from "./Click2PayPrcessErrorModal.vue?vue&type=script&lang=js"
import style0 from "./Click2PayPrcessErrorModal.vue?vue&type=style&index=0&id=6c303ee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c303ee5",
  null
  
)

export default component.exports